import { ConfigProvider, type ConfigProviderProps, ThemeConfig } from 'antd';
import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export type ThemeProps = {
  /**
   * Override the default light theme
   */
  lightTheme?: string;
  /**
   * Override the default dark theme
   */
  darkTheme?: string;
  /**
   * colors to override the default theme colors
   */
  colors?: string;
  /**
   * fonts to override the default theme fonts
   */
  fonts?: string;
  /**
   * antd's own strings (date picker, pagination, empty states) in the UI's language. antd's
   * default is US English, which is what an app that passes nothing keeps.
   */
  locale?: ConfigProviderProps['locale'];
} & HTMLAttributes<HTMLDivElement>;

export const Theme = ({ children, lightTheme, darkTheme, colors, fonts, className, locale }: ThemeProps) => {
  const token: ThemeConfig['token'] = {
    colorPrimary: '#1e00d5',
    colorSuccess: '#2DD881',
    colorError: '#EF3E31',
    colorWarning: '#FAAD14',
    colorLink: '#1e00d5',
    borderRadius: 12,
    fontFamily: fonts,
  };

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        hashed: false,
        token,
        components: {
          Layout: {
            headerBg: 'white',
          },
        },
      }}
    >
      <div className={classNames(className, colors, fonts, lightTheme, darkTheme)}>{children}</div>
    </ConfigProvider>
  );
};
